import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerDatosPoliza = async (form: string, origen = "WEB") => {
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }
    const {status, data} = await Axios.get( await getPathName() + `/GetFormulariosJSON?hash=${await getApiHash()}&form=${form}&origen=${origen}`, {
        headers
    });

    return data.api_data
};

export default obtenerDatosPoliza;